export default class Footer {

  constructor(el) {
    this.el = el
    if (window.matchMedia('(max-width: 991px)').matches) {
      this.initAccordions()
    }
    this.bindNewsletter()
  }

  bindNewsletter() {
    this.newsletterForm = this.el.querySelector('.footer--newsletter-form')
    if (!this.newsletterForm) return

    this.newsletterFeedback = this.newsletterForm.querySelector('.footer--newsletter-feedback')
    this.newsletterMailer = this.newsletterForm.dataset.mailer

    this.newsletterForm.querySelectorAll('.footer--newsletter-checkbox-container').forEach(container => {
      container.addEventListener('click', (e) => {
        const checkbox = container.querySelector('.footer--newsletter-input-checkbox')
        if (e.target !== checkbox) checkbox.checked = !checkbox.checked
      })
    })

    this.newsletterForm.addEventListener('submit', (e) => {
      e.preventDefault()

      const amispam = this.newsletterForm.querySelector('#amispam-newsletter')
      if (amispam?.value) return

      const submit = this.newsletterForm.querySelector('.footer--newsletter-submit')
      submit.disabled = true

      fetch(this.newsletterMailer, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(this.newsletterForm),
      })
        .then(res => {
          if (!res.ok) throw new Error(res.statusText)
          this.setNewsletterFeedback('Merci pour votre inscription !')
          this.newsletterForm.reset()
        })
        .catch(err => {
          console.error(err)
          this.setNewsletterFeedback('Une erreur est survenue, veuillez réessayer.')
        })
        .finally(() => {
          submit.disabled = false
        })
    })
  }

  setNewsletterFeedback(message) {
    if (!this.newsletterFeedback) return
    this.newsletterFeedback.textContent = message
  }

  initAccordions() {
    // Footer text (accès et distances)
    const footerText = this.el.querySelector('.footer--text')
    if (footerText) {
      const toggle = document.createElement('div')
      toggle.className = 'footer--title-menu footer--accordion-toggle'
      toggle.innerHTML = '<span>Accès et distances</span>'
      footerText.insertBefore(toggle, footerText.firstChild)
      this._makeAccordion(footerText, toggle, Array.from(footerText.children).filter(el => el !== toggle))
    }

    // Cols avec .footer--title-menu (menu, cures, contact)
    this.el.querySelectorAll('.footer--title-menu:not(.footer--accordion-toggle)').forEach(title => {
      const col = title.parentElement
      if (!col) return
      this._makeAccordion(col, title, Array.from(col.children).filter(el => el !== title))
    })

    // Col tarifs : pas de title-menu, le premier li fait office de titre
    const tarifsCol = this.el.querySelector('.footer--col-tarifs')
    if (tarifsCol) {
      const menu = tarifsCol.querySelector('.footer--menu-list--title')
      if (menu) {
        const firstLi = menu.querySelector('li:first-child')
        const otherLis = Array.from(menu.querySelectorAll('li:not(:first-child)'))
        if (firstLi && otherLis.length) {
          firstLi.classList.add('footer--accordion-toggle', 'footer--title-menu')
          this._makeAccordion(tarifsCol, firstLi, otherLis, menu)
        }
      }
    }
  }

  _makeAccordion(col, toggle, contentEls, appendTo = null) {
    const body = document.createElement('div')
    body.className = 'footer--accordion-body'
    contentEls.forEach(el => body.appendChild(el))
    ;(appendTo || col).appendChild(body)
    body.style.height = '0'

    toggle.classList.add('footer--accordion-toggle')
    toggle.addEventListener('click', () => {
      const isOpen = col.classList.toggle('is-open')
      body.style.height = isOpen ? body.scrollHeight + 'px' : '0'
    })
  }

}
